import { useTranslation } from "react-i18next";

export default function LanguageSwitcher({ variant = "default" }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "it";

  const setLang = (lng) => {
    i18n.changeLanguage(lng);
  };

  const langs = [
    { code: "it", label: "IT" },
    { code: "en", label: "EN" },
  ];

  if (variant === "mobile") {
    return (
      <div className="flex items-center gap-3" data-testid="lang-switcher-mobile">
        {langs.map((l) => (
          <button
            key={l.code}
            data-testid={`lang-mobile-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`text-base px-3 py-1.5 transition-colors ${
              current === l.code
                ? "text-[#C4A462] border border-[#C4A462]"
                : "text-[#4A4A4A] border border-transparent hover:text-[#1A1B1A]"
            }`}
            style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 500, letterSpacing: "0.15em" }}
          >
            {l.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1" data-testid="lang-switcher">
      {langs.map((l, idx) => (
        <span key={l.code} className="flex items-center">
          <button
            data-testid={`lang-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`text-[11px] uppercase tracking-[0.15em] px-1 transition-colors duration-300 ${
              current === l.code
                ? "text-[#C4A462]"
                : "text-[#757575] hover:text-[#1A1B1A]"
            }`}
            style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}
          >
            {l.label}
          </button>
          {idx === 0 && <span className="text-[#D8D4CC] text-[10px]">|</span>}
        </span>
      ))}
    </div>
  );
}
